export default {
	ACTIVITY_TYPES: 'companies/:company_id/activity/activity-types/',
	ACTIVITY: 'companies/:company_id/activity/',
	AUDITING: 'companies/:company_id/audit/',
	FILTERS: 'companies/:company_id/audit/filters/'
}
